import Vue from '../../assets/vue';
import Logger from '../../scripts/config/logger';
import { SENTRY_ERRORS } from '../../scripts/config/constants';

const backInStockKlaviyoRequest = (variantID, clientEmail) => {
  const options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      revision: '2023-09-15',
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: { type: 'profile', attributes: { email: clientEmail } },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantID}`,
            },
          },
        },
      },
    }),
  };

  return fetch(
    'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=LJzKng',
    options
  ).then((response) => {
    if (!response.ok) {
      return Promise.reject(new Error(`Response status ${response.status}`));
    }
    return Promise.resolve(response);
  });
};

const productWishListModal = ({ variantId }) => ({
  data() {
    this.isComponentCreated = false;

    return {
      isOpen: false,
      activeVariantId: variantId,
      isRequestLoading: false,
      isRequestSuccess: false,
      isRequestFail: false,
    };
  },
  methods: {
    closeModal() {
      this.isOpen = false;
      this.resetFormData();
    },
    openModal() {
      this.isOpen = true;
    },
    resetFormData() {
      this.isRequestLoading = false;
      this.isRequestSuccess = false;
      this.isRequestFail = false;
      this.$refs.clientEmail.value = '';
    },
    backInStockSubmit(event) {
      event.preventDefault();

      const clientEmail = this.$refs.clientEmail.value;
      const apiResponse = backInStockKlaviyoRequest(
        this.activeVariantId,
        clientEmail
      );

      this.isRequestLoading = true;

      apiResponse
        .then(() => {
          this.isRequestLoading = false;
          this.isRequestSuccess = true;
          this.isRequestFail = false;
        })
        .catch((error) => {
          this.isRequestLoading = false;
          this.isRequestSuccess = false;
          this.isRequestFail = true;
          Logger.error(error, SENTRY_ERRORS.BACK_IN_STOCK_ERROR);
        });
    },
    updateModalState({ newVariantId }) {
      this.activeVariantId = newVariantId;

      this.$forceUpdate();
    },
  },
  created() {
    this.isComponentCreated = true;
  },
});

export const initProductWishListModal = (config) => {
  if (document.querySelector('#product-wish-list-modal')) {
    window.productWishListModal = new Vue(productWishListModal(config)).$mount(
      '#product-wish-list-modal'
    );
  }
};
